import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { queuesApi } from '@/services/api/endpoints/queuesApi'
import { visitorsApi } from '@/services/api/endpoints/visitorsApi'
import type { DateRange } from '@/services/api/params'
import { queryKeys } from '@/services/api/queryKeys'

/** Очередь на кассах сейчас (ТЗ п. 5.1) — текущее состояние, источник обновляется раз в несколько минут. */
export const useQueuesQuery = () =>
  useQuery({
    queryKey: queryKeys.queues,
    queryFn: queuesApi.getCurrent,
    refetchInterval: 60_000,
    staleTime: 30_000,
  })

/** Средняя очередь и ряд за период (ТЗ п. 5.2, 5.4). range — из useMemo. */
export const useQueuesHistoryQuery = (range: DateRange) =>
  useQuery({
    queryKey: queryKeys.queuesHistory(range),
    queryFn: () => queuesApi.getHistory(range),
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  })

/** Входы посетителей за период (ТЗ п. 5.3, 5.5). Продюсер публикует бакеты раз в час — опрос редкий. */
export const useVisitorsQuery = (range: DateRange) =>
  useQuery({
    queryKey: queryKeys.visitors(range),
    queryFn: () => visitorsApi.getVisitors(range),
    placeholderData: keepPreviousData,
    refetchInterval: 5 * 60_000,
    staleTime: 60_000,
  })
